import React, { Component } from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'
import { stores, createStore, view } from '../../stores'
import { Input } from '../ui/inputs/Input'
import { CheckBox } from '../ui/inputs/CheckBox'
import { getErrorTranslation } from '../../utilities/errors'
import { isEmail } from '../../utilities/validators'

class SignInComponent extends Component {
  constructor () {
    super()
    this.store = createStore({})
  }

  async onAuthenticate (password, rememberMe) {
    const { onAuthentication, t } = this.props
    this.store.message = null

    try {
      await stores.authentication.authenticate({ password, rememberMe })
      onAuthentication()
    } catch (e) {
      this.store.message = { type: 'form__errormessage', text: getErrorTranslation(t, e) }
    }
  }

  async forgetPassword () {
    const { t: translate } = this.props
    const email = stores.authentication.email
    let message = null

    if (email === '') {
      message = { type: 'form__errormessage', text: translate('common:fields:error_forgot_password') }
    } else if (!isEmail(email)) {
      message = { type: 'form__errormessage', text: translate('common:fields:error_email') }
    }

    if (message) {
      this.store.message = message
      return
    }

    try {
      await stores.authentication.askResetPassword()
      message = { type: 'form__message', text: translate('common:fields:message_forgot_password') }
    } catch (e) {
      message = { type: 'form__errormessage', text: getErrorTranslation(translate, e) }
    }
    this.store.message = message
  }

  updateEmail (value) {
    this.store.message = null
    stores.authentication.email = value
  }

  render () {
    const { t } = this.props
    return (
      <div>
        {
          this.store.message
          ? <p className={this.store.message.type}>{this.store.message.text}</p>
          : <span />
        }
        <Input value={stores.authentication.email || ''} onChange={(value) => this.updateEmail(value)} ref='email' label='Email' name='email' type='text' />
        <Input ref='password' label='Mot de passe' name='password' type='password' />
        <a onClick={() => this.forgetPassword()} className='signup__forgotpass' href='#'>{t('common:fields:forgotpass')}</a>

        <CheckBox
          ref='remember'
          label={t('common:fields:remember')} name='remember' checked />

        <button
          onClick={() => this.onAuthenticate(this.refs.password.state.value, this.refs.remember.isChecked)}
          className='btn--default layout--centered signup__btn'>
          { t('common:buttons:signin') }
        </button>
      </div>
    )
  }
}

SignInComponent.propTypes = {
  t: func,
  onAuthentication: func
}

export const SignIn = translate()(view(SignInComponent))



// WEBPACK FOOTER //
// ./src/components/authentication/SignIn.js